import { Values } from '@/firebase/index';

export default {
  getAllValues() {
    return Values.get();
  }
};
